import { addBankAccount } from 'api/CybridBank/addBankAccount';
import { getPlaidToken } from 'api/CybridBank/getPlaidToken';
import { initBankAddition } from 'api/CybridBank/initBankAdd';
import { AutoClose } from 'components/shared/AutoClose';
import LoadingScreen from 'components/shared/LoadingScreen';
import { usePolling } from 'hooks/usePolling';
import React, { useCallback, useEffect, useState } from 'react';
import { closeWindow } from "utils/closeWindow";

import {
    PlaidLinkOnExit,
    PlaidLinkError,
    PlaidLinkOnSuccess,
    usePlaidLink,
    PlaidLinkOnExitMetadata,

} from 'react-plaid-link';

interface Props {
    token: string | null
    redirectUrl: string | null
}

const CybridBankAddition: React.FC<Props> = ({ token, redirectUrl }) => {
    const [polling, setPolling] = useState<boolean>(false);
    const [_token, setToken] = useState<string | null>(token);
    const [close, setClose] = useState<boolean>(false);

    useEffect(() => {
        if (token) return;

        const initializeToken = async () => {
            const success = await initBankAddition();
            if (success) {
                setPolling(true);
            }
        };
        initializeToken();
    }, [token]);

    usePolling({
        interval: 5_000,  // 5 seconds
        maxInterval: 120_000, // 2 minutes
        onPoll: async () => {
            const response = await getPlaidToken();
            return response;
        },
        onSuccess: (result) => {
            if (result.token) {
                setToken(result.token)
                setPolling(false);
            }
        },
        dependencies: [],
        dependencyCondition: !_token && polling,
    });

    const onSuccess: PlaidLinkOnSuccess = async (publicToken, metadata) => {
        await addBankAccount({
            partner_account_id: metadata.accounts[0].id,
            public_token: publicToken,
        });

        setClose(true);
    };

    const onExit: PlaidLinkOnExit = useCallback(async (error: PlaidLinkError | null, metadata: PlaidLinkOnExitMetadata) => {
        // TODO: Handle invalid link token
        // if (error != null && error.error_code === 'INVALID_LINK_TOKEN') {
        //     const success = await initBankAddition();
        //     if (success) {
        //         setPolling(true);
        //     }
        // }

        await addBankAccount({
            status: error?.error_code || "UNKNOWN_ERROR",
            error: error?.error_message || "Unknown error",
        });

        setClose(true);
        },
        [],
    );

    const { open, ready } = usePlaidLink({
        token: _token,
        onSuccess,
        onExit
    });

    const autoClose = () => {
        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            closeWindow()
        }
    }


    useEffect(() => {
        if (_token && ready) {
            open();
        }
    }, [_token, ready]);

    return (close ? <AutoClose
        delayInSeconds={10}
        runner={autoClose}
        message="You can now close this window"
    />
        : <LoadingScreen />);
};

export default CybridBankAddition;